(function () {

  'use strict';

  angular.module('eclipseApp.myAccount')

    .controller('changePhoneNumberRedesignSelectionCtrl', ['$scope', 'provinceMeta', '$sce', '$http', 'uteEndpoint', 'uteLocale', '$rootScope', '$stateParams', '$state', 'commonService', 'changePhoneNumberService', 'dataLayerService', 'dtmServiceConstants', '$translate', function ($scope, provinceMeta, $sce, $http, uteEndpoint, uteLocale, $rootScope, $stateParams, $state, commonService, changePhoneNumberService, dataLayerService, dtmServiceConstants, $translate) {

      $scope.showNoMoreCTNLink = true;
      $scope.showLoader = false;

      var selectedAccountDetail = '';
      var lastNumberToSend = '';
      var accountNumber = $stateParams.accountNumber;
      $scope.showNoMoreCTN = false;
      $scope.planIsCollapsed = false ;
      $scope.subscriberNo = $stateParams.ctn;
      $scope.accountNumber = $stateParams.accountNumber;
      $scope.selectedCityCode = $stateParams.selectedCityCode;
      $scope.selectedProvinceCode = $stateParams.selectedProvinceCode;
      $scope.language = uteLocale.language;
      $scope.lengthOfCTN = 0;
      $scope.data = {
        selectedOption: ''
      };
      $scope.errorPayload = {
        page: dtmServiceConstants.dataLayerTrack.page.changeCtn.error
      };

      if ($stateParams.accountNumber) {
        selectedAccountDetail = _.find(commonService.accountDetails, function (accountDetail) {
          return accountDetail.accountNumber === $stateParams.accountNumber
        });
      }

      if (selectedAccountDetail) {
        if (selectedAccountDetail.LOB === 'WL') {
          $scope.customerType = 'postpaid';
        }
        else {
          $scope.customerType = 'prepaid';
        }
      }

      $scope.trackMoreNumberOption = function(step, type, addBasicSections) {
        var interaction = {};
        var  page = dtmServiceConstants.dataLayerTrack.page.changeCtn[step];
        var addSection = [];

        /**
         * Set event for SelfServe transaction
         */
        if (step === 'selectNumber' && type === 'moreNumbers') {
          page = dtmServiceConstants.dataLayerTrack.page.changeCtn.selectNumber;
          interaction = dtmServiceConstants.dataLayerTrack.interaction.changeCtn;
          addSection = _.union([dtmServiceConstants.dataLayerTrack.basicPayload.interAction], addBasicSections);
        }

        var payload = {
          page: page,
          interaction: interaction
        };

        /**
         * Remove empty objects from payload
         */
        if (_.isEmpty(payload.interaction)) {
          delete payload.interaction;
        }
        dataLayerService.trackDataLayer(payload, false, addSection);
      };

      $scope.getCityLabel = function () {
        if (!(_.isEmpty(changePhoneNumberService.getCityList()))) {
          $.each(changePhoneNumberService.getCityList(), function (key, value) {
            if (value.cityCode === $scope.selectedCityCode) {
              $scope.cityNameLabel = value.cityName;
            }
          });
          changePhoneNumberService.setProvince($scope.selectedProvinceCode);
          changePhoneNumberService.setCityName($scope.cityNameLabel);
        };
      };

      $scope.cancel = function() {
        $state.go('myAccount.changePhoneNumber', {
          'accountNumber': $scope.accountNumber,
          'ctn': $scope.subscriberNo
        });
      };

      $scope.getListOfCTN = function () {
        $scope.showLoader = true;
        $http({
          method: "POST",
          url: uteEndpoint('v1/wirelesss/changenumber/newnumbers'),
          data: {
            accountNumber: $stateParams.accountNumber,
            ctn: $stateParams.ctn,
            cityCode: $scope.selectedCityCode,
            lastNumber: lastNumberToSend
          }
        }).success(function (response, status, headers, config) {
          $scope.showLoader = false;
          $scope.getCityLabel();
          if (!(_.isEmpty(response))) {
            if(response.error){
              $scope.errorMessage = 'errorOccurred';
            }  else if (_.isEmpty(response.newPhoneNoList) && (_.isEmpty(lastNumberToSend))) {
              $scope.errorMessage = 'dataEmpty';
              $translate('wireless.label.noMoreNumbersAvailable').then(function (translatedValues) {
                var errorCode = angular.isString(response.error) ? response.error : '';
                var apiUrl = (config && config.url)? config.url : dtmServiceConstants.dataLayerTrack.page.changeCtn.errorType.retrieveNewNumbers;
                dataLayerService.trackServerSideError($scope.errorPayload, translatedValues, errorCode, apiUrl, dtmServiceConstants.dataLayerTrack.errorType.http, false, dtmServiceConstants.dataLayerTrack.basicPayloadInfo);
              });
            } else if (_.isEmpty(response.newPhoneNoList)) {
              $scope.showNumberList = false;
              $scope.lengthOfCTN = 0;
            } else {
              if (response.newPhoneNoList && response.newPhoneNoList.length < 7) {
                $scope.showNoMoreCTNLink = true;
              }
              else {
                $scope.showNoMoreCTNLink = false;
              }
              $scope.newPhoneList = response.newPhoneNoList;
              $scope.lengthOfCTN = response.newPhoneNoList.length;
              lastNumberToSend = response.newPhoneNoList[$scope.lengthOfCTN - 1];
              $scope.showNumberList = true;
              $scope.errorMessage = 'dataAvailable';
            }
          }
        }).error(function (response) {
          $scope.showLoader = false;
          $scope.errorMessage = 'errorOccurred';
        });
      };

      $scope.submit = function () {
        if ($scope.changeCTNForm.$valid && $scope.data.selectedOption) {
          $state.go('myAccount.changePhoneNumberReviewRedesign', {
            'accountNumber': $stateParams.accountNumber,
            'oldCTN': $stateParams.ctn,
            'newCTN': $scope.data.selectedOption,
            'cityCode': $scope.selectedCityCode
          });
        } else {
          if ($scope.changeCTNForm && $scope.changeCTNForm.ctnNumber) {
            $scope.changeCTNForm.ctnNumber.$setValidity('required',false);
          }
        }
      };

      $scope.getMoreNumbers = function () {
        $scope.changeCTNForm.$valid = true;
        $scope.showNumberList = false;
        $scope.newPhoneList = '';
        $scope.trackMoreNumberOption('selectNumber', 'moreNumbers', dtmServiceConstants.dataLayerTrack.basicPayloadInfo);
        $scope.getListOfCTN();
        $scope.changeCTNForm.$setPristine();
        $scope.changeCTNForm.$setUntouched();
        $scope.data.selectedOption = null;
      };


      $scope.activate = function () {
        $scope.getListOfCTN();
      };

      $scope.activate();

    }]);

})();
